import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { PlatformProvider } from './contexts/PlatformContext';
import { ChooseProfile } from './pages/ChooseProfile';
import { Confirmed } from './pages/Confirmed';
import { Login } from './pages/Login';
import { Plan } from './pages/Plan';
import { Profile } from './pages/Profile';
import { Results } from './pages/Results';
import { Review } from './pages/Review';
export function App() {
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return <div className="dark min-h-screen w-full bg-[#0f1017] font-heading text-foreground antialiased" data-id="element-0" data-mp="31bi7xhgaoacs">
      <BrowserRouter data-id="element-1" data-mp="2wiff5bjcd4xn">
        <PlatformProvider data-id="element-2" data-mp="2whxbhtucnofp">
          <Routes data-id="element-3" data-mp="28u5zkrcq1dey">
            <Route path="/" element={<Login data-id="element-5" data-mp="28suumo7jhzm9" />} data-id="element-4" data-mp="28tmdqzjya4vn" />
            <Route path="/choose-profile" element={<ChooseProfile data-id="element-7" data-mp="23vuq4hqc94x9" />} data-id="element-6" data-mp="28sbar1ybx15l" />
            <Route element={<AppShell data-id="element-9" data-mp="23v2sl1d6kx4c" />} data-id="element-8" data-mp="23ujha3i1d6za">
              <Route path="/profile" element={<Profile data-id="element-11" data-mp="3ikqz80j1f669" />} data-id="element-10" data-mp="3ijxnsm94vshs" />
              <Route path="/results" element={<Results data-id="element-13" data-mp="3ii4q3wgi0ilx" />} data-id="element-12" data-mp="3ijfu9xduvsdk" />
              <Route path="/plan" element={<Plan data-id="element-15" data-mp="3mk84otygs3bf" />} data-id="element-14" data-mp="3ml17xky7saot" />
              <Route path="/review" element={<Review data-id="element-17" data-mp="3rcj7c4kla37o" />} data-id="element-16" data-mp="3mjg8bgx1m1k3" />
              <Route path="/confirmed" element={<Confirmed data-id="element-19" data-mp="3rd189ei755lx" />} data-id="element-18" data-mp="3rdas0kcnegj6" />
            </Route>
            <Route path="*" element={<Navigate to="/" replace data-id="element-21" data-mp="4n5w26l2pak" />} data-id="element-20" data-mp="6htjo98ovic" />
          </Routes>
        </PlatformProvider>
      </BrowserRouter>
    </div>;
}